
/**
 * Partner entity.
 */


import { Field, ObjectType } from "./decorators";

/**
 * Combined vetting data returned by API.
 */
@ObjectType()
export class VetResults {
  @Field() vetReportId!: number;
  @Field() vetRequestId?: string;
  @Field() vettedEntity?: string;
  @Field() vetDate?: Date;
  @Field() errorCode?: string;
  @Field() errorDescription?: string;
  @Field() findings!: string[];
}



@ObjectType()
export class Partner {

  @Field({ key: true, q: ['summary', 'sdlist'] }) partnerId!: number;
  @Field({ key: true, q: ['summary', 'sdlist'] }) partnerType!: string;
  @Field({ q: ['summary', 'sdlist'] }) public accountId!: number;
  @Field({ q: ['summary', 'sdlist'] }) public company!: string;
  @Field({ q: ['summary', 'sdlist'] }) public firstName!: string;
  @Field({ q: ['summary', 'sdlist'] }) public lastName!: string;
  @Field() public phone!: string;
  @Field() public phoneExtension?: string;
  @Field({ q: ['summary', 'sdlist'] }) public email!: string;
  @Field() public address1!: string;
  @Field() public address2!: string;
  @Field() public city!: string;
  @Field() public state!: string;
  @Field() public country!: string;
  @Field() public zip!: string;
  @Field() public legalEntityType!: string | undefined;
  @Field() public dba?: string;
  @Field() public registration!: string;
  @Field() public companyUrl!: string;
  @Field() public companySymbol!: string;
  @Field({ q: ['summary'] }) public fein!: string;
  @Field({ q: ['summary'] }) public duns!: string;
  @Field() public giin!: string;
  @Field() public lei!: string;
  @Field() public subsidiaries!: string[];
  @Field({ q: ['summary', 'sdlist'] }) public vetStatus!: string;
  @Field({ q: ['summary', 'sdlist'] }) public vetStatusReason!: string;
  @Field({ q: ['summary', 'sdlist'] }) public vetReportId?: number;
  @Field() public vetStatusUpdateTime?: Date;

  public createTime!: Date;
  public updateTime!: Date;

  // local.
  public detailsLoaded!: boolean;
  public vetStatusAndReason!: string; // filter column

  @Field({sub: ()=>VetResults}) vetResults?: VetResults;
  scIds?: number[];
  scIdCount?: number;

}
